import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import styles from "./COATitle2.module.scss";

const Title2 = ({ children, white = false, sx = {} }) => (
  <Box className={`${white ? styles.white : ""} ${styles.title2}`} sx={sx}>
    {children}
  </Box>
);

Title2.propTypes = {
  children: PropTypes.node.isRequired,
  white: PropTypes.bool,
  sx: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

export default Title2;
